import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Background } from "../Background";
import { Button } from "../../utils/Button";
import { AdversaryAvatarContainer } from "./AdversaryAvatarContainer";
import { GemsContainerMatchingScene } from "./GemsContainerMatchingScene";
import { Game } from "../../Game";
import { AudioManager } from "../../AudioManager";
import BattleUtils from "../../gzp/BattleUtils";
import { BootScene } from "../BootScene";

export class MatchingScene extends Phaser.Scene {

    public static currentInstance: MatchingScene;

    private scaledItemsContainer: Phaser.GameObjects.Container;
    private playerAvatarContainer: Phaser.GameObjects.Container;
    private adversaryAvatarContainer: AdversaryAvatarContainer;
    private matchingLabel: Phaser.GameObjects.Text;
    private matchingLabelTween: Phaser.Tweens.Tween;
    private vsRaysTween: Phaser.Tweens.Tween;
    private vs: Phaser.GameObjects.Image;
    private vsRays: Phaser.GameObjects.Sprite;
    private gemsLabel: Phaser.GameObjects.Text;
    private backButton: Button;
    constructor() {

        super("MatchingScene");

        MatchingScene.currentInstance = this;
    }

    init(data: any) {
        console.log(data);
        GameManager.setCurrentScene(this);
        if (data.doesBattleHasBots) {
            this.time.addEvent({
                callback: GameManager.onMatchingNotPossible,
                callbackScope: this,
                args: [data.doesBattleHasBots],
                delay: 2000
            })
        }
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const background = new Background(this, 1);
        this.add.existing(background);

        const topItemsContainer = this.add.container(0, 0);
        topItemsContainer.scaleY = GameVars.scaleY;

        this.gemsLabel = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH - 30, 50 + (BootScene.textYgap * -64), GameVars.formatNumber(GameVars.gameData.gems), { fontFamily: "Teko-Medium", fontSize: "48px", color: "#FFFFFF" });
        this.gemsLabel.setShadow(0, 5, "#061f55", 0, false, true);
        this.gemsLabel.setOrigin(1, BootScene.originY);
        topItemsContainer.add(this.gemsLabel);

        const gemIcon = new Phaser.GameObjects.Image(this, this.gemsLabel.x - 105, 50, "texture_atlas_1", "icon_top_gems");
        gemIcon.setOrigin(1, .5);
        topItemsContainer.add(gemIcon);

        this.backButton = new Button(this, 10, 10, "texture_atlas_1", "btn_back_off", "btn_back_on");
        this.backButton.setOrigin(0);
        this.backButton.onDown(this.onClickBack, this);
        topItemsContainer.add(this.backButton);

        if (BattleUtils.isBattle) {
            topItemsContainer.visible = false;
        }
        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        this.scaledItemsContainer.scaleY = GameVars.scaleY;

        // VS
        this.vsRays = this.add.sprite(0, 0, "texture_atlas_1", "vs_rays");
        this.vsRays.blendMode = Phaser.BlendModes.OVERLAY;
        this.scaledItemsContainer.add(this.vsRays);

        this.vsRaysTween = this.add.tween({
            targets: this.vsRays,
            scaleX: 1.2,
            scaleY: 1.2,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 600,
            yoyo: true,
            repeat: -1
        });

        this.vs = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "txt_vs");
        this.vs.setScale(.8);
        this.scaledItemsContainer.add(this.vs);

        // PLAYER
        this.playerAvatarContainer = new Phaser.GameObjects.Container(this);
        this.playerAvatarContainer.x = -200;
        this.scaledItemsContainer.add(this.playerAvatarContainer);

        const playerName = new Phaser.GameObjects.Text(this, 0, -80 + (BootScene.textYgap * 64), GameVars.playerData.name + "\n", { fontFamily: "Teko-Medium", fontSize: "30px", color: "#FFFFFF" });
        playerName.setShadow(0, 3, "#061f55", 0, false, true);
        playerName.setOrigin(.5,BootScene.originY);
        this.playerAvatarContainer.add(playerName);

        const playerImage = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "avatar-gamezop-2");
        this.playerAvatarContainer.add(playerImage);
        this.loadPlayerProfilePic(playerImage);
        const playerFrame = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "icon_basic_frame");
        this.playerAvatarContainer.add(playerFrame);

        // ADVERSARY
        this.adversaryAvatarContainer = new AdversaryAvatarContainer(this);
        this.adversaryAvatarContainer.x = 200;
        this.scaledItemsContainer.add(this.adversaryAvatarContainer);

        let matchText: string = "MATCHING";
        if (BattleUtils.isBattle) {
            matchText = "WAITING FOR OPPONENT..";
        }

        this.matchingLabel = new Phaser.GameObjects.Text(this, 0, 200 + (BootScene.textYgap * -50), matchText, { fontFamily: "Teko-Medium", fontSize: "66px", color: "#FFFFFF" });
        this.matchingLabel.setShadow(0, 3, "#061f55", 0, false, true);
        this.matchingLabel.setOrigin(.5,BootScene.originY);
        this.scaledItemsContainer.add(this.matchingLabel);

        this.matchingLabelTween = this.add.tween({
            targets: this.matchingLabel,
            alpha: 0.35,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 200,
            yoyo: true,
            repeat: -1
        });

        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", function (): void {
                Game.currentInstance.launchIntoFullscreen(document.documentElement);
            }, this);
        }

        AudioManager.stopMusic();

        AudioManager.playMatching("matching");
    }

    public update(): void {

        this.adversaryAvatarContainer.update();
    }

    public onAdversaryJoined(): void {
        console.log(" adversary joined :> ");
        if (this.backButton) {
            this.backButton.visible = false;
        }

        this.adversaryAvatarContainer.onAdversaryJoined();

        this.matchingLabelTween.stop();
        this.matchingLabel.destroy();

        this.vsRaysTween.stop();

        this.add.tween({
            targets: this.vsRays,
            scaleX: 1.65,
            scaleY: 1.65,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 250,
            yoyo: true,
            repeat: -1
        });


        this.add.tween({
            targets: this.vs,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Elastic.Out,
            duration: 600
        });

        this.add.tween({
            targets: this.playerAvatarContainer,
            x: -160,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300
        });

        this.add.tween({
            targets: this.adversaryAvatarContainer,
            x: 160,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300
        });

        this.gemsLabel.text = GameVars.formatNumber(GameVars.gameData.gems);

        const gemsContainer = new GemsContainerMatchingScene(this);
        if (BattleUtils.isBattle) {
            gemsContainer.visible = false;
        }
        this.scaledItemsContainer.add(gemsContainer);

        AudioManager.stopMatching();
    }

    private onClickBack(): void {

        AudioManager.playSound("click_btn");

        AudioManager.stopMatching();

        GameManager.leaveMatchingScene();
    }

    private loadPlayerProfilePic(playerAvatar: Phaser.GameObjects.Image) {
        if (!BattleUtils.battlePlayerData.photo) {
            console.warn("Profile picture not available, player");
            playerAvatar.setTexture("texture_atlas_1", "avatar-gamezop-2");
            return;
        }
        const loader = new Phaser.Loader.LoaderPlugin(this);
        const cachekey = "playercache" + Math.floor(Math.random() * 1000);
        BattleUtils.playerProfileCache = cachekey;
        loader.image(cachekey, BattleUtils.getValidLoadUrl(BattleUtils.battlePlayerData.photo));
        loader.once("filecomplete", (key) => {
            playerAvatar.setTexture(cachekey);
            playerAvatar.displayHeight = 100;
            playerAvatar.displayWidth = 100;
        });
        loader.once("loaderror", (e) => {
            console.log("Image load error, fallback to defautl");
            BattleUtils.playerProfileCache = undefined;
            playerAvatar.setTexture("texture_atlas_1", "avatar-gamezop-2");
        });
        loader.crossOrigin = "anonymous";
        loader.start();
    }
}
